import React from "react";

const RankSkeleton = () => {
  return (
    <div
      style={{
        background: "#f1e8dd",
        // background:
        //   "linear-gradient(135deg,rgb(189, 190, 195) 0%,rgb(204, 198, 210) 100%)",
        minHeight: "100vh",
        padding: "20px",
        paddingBottom: "200px",
      }}
    >
      <div style={{ maxWidth: "600px", margin: "0 auto" }}>
        {/* Title Skeleton */}
        <div
          style={{
            height: "28px",
            width: "280px",
            backgroundColor: "rgba(144, 137, 137, 0.3)",
            borderRadius: "8px",
            marginBottom: "24px",
            // animation: "shimmer 1.5s infinite",
          }}
        />

        {/* Prize Banner Skeleton */}
        <div
          style={{
            width: "100%",
            height: "300px",
            backgroundColor: "rgba(144, 137, 137,0.3)",
            borderRadius: "16px",
            marginBottom: "24px",
            // animation: "shimmer 1.5s infinite",
          }}
        />

        {/* Rank Holders Title Skeleton */}
        <div
          style={{
            height: "24px",
            width: "150px",
            backgroundColor: "rgba(144, 137, 137, 0.3)",
            borderRadius: "8px",
            marginBottom: "16px",
            // animation: "shimmer 1.5s infinite",
          }}
        />

        {/* Rank Holders List Skeleton */}
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {[1, 2, 3, 4, 5].map((index) => (
            <div
              key={index}
              style={{
                background: "rgba(17, 24, 39, 0.8)",
                borderRadius: "12px",
                padding: "16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                // animation: "shimmer 1.5s infinite",
                // animationDelay: `${index * 0.1}s`,
              }}
            >
              <div
                style={{
                  height: "18px",
                  width: "120px",
                  backgroundColor: "rgba(255,255,255,0.2)",
                  borderRadius: "4px",
                }}
              />
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <div
                  style={{
                    height: "14px",
                    width: "60px",
                    backgroundColor: "rgba(255,255,255,0.2)",
                    borderRadius: "4px",
                  }}
                />
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    backgroundColor: "rgba(255,255,255,0.3)",
                    borderRadius: "50%",
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* User Info Card Skeleton */}
        <div
          style={{
            backgroundColor: "rgba(255,255,255,0.9)",
            padding: "15px",
            borderRadius: "25px",
            display: "flex",
            alignItems: "center",
            position: "fixed",
            bottom: "90px",
            left: "10px",
            right: "10px",
            zIndex: "1000",
            maxWidth: "600px",
            margin: "0 auto",
            // animation: "shimmer 1.5s infinite",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              backgroundColor: "rgba(251, 191, 36, 0.3)",
              borderRadius: "50%",
              marginRight: "10px",
            }}
          />
          <div style={{ textAlign: "left", marginLeft: "10px", flex: 1 }}>
            <div
              style={{
                height: "18px",
                width: "80px",
                backgroundColor: "rgba(0,0,0,0.1)",
                borderRadius: "4px",
                marginBottom: "4px",
              }}
            />
            <div
              style={{
                height: "18px",
                width: "120px",
                backgroundColor: "rgba(0,0,0,0.1)",
                borderRadius: "4px",
              }}
            />
          </div>
          <div
            style={{
              height: "18px",
              width: "100px",
              backgroundColor: "rgba(0,0,0,0.1)",
              borderRadius: "4px",
            }}
          />
        </div>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          0% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0.6;
          }
        }
      `}</style>
    </div>
  );
};

export default RankSkeleton;
